const Template = `
<div class="left-menu-modems">
  <ag-grid-vue
    class="ag-theme-balham-dark ag-theme-rtube left-menu-modems__top"
    :columnDefs="fields"
    :rowData="transformedModemRows"
    pagination="true"
    :paginationPageSize="perPage"
    rowSelection="single"
    @first-data-rendered="onFirstDataRendered"
    @grid-ready="onGridReady"
    @selection-changed="onModemChanged">
  </ag-grid-vue>
  
  <div class="left-menu-modems__bottom" v-show="selectedModem">
    <h2>{{selectedModemLogs.dev ?? "123"}}</h2>
    <div>
      <p class="current-modem-item" v-for="field in modemInfoFields">
        <span>{{field.label}}</span>
        <b>{{field.value}}</b>
      </p>
    </div>
    <div class="saveButtonWrapper">
        <span>{{$t('modems.comment')}}</span>
        <button class="input-dark form-control" :disabled="!(newComment!==selectedModem?.comment&&newComment!=='')" @click="updateComment">{{$t('modems.saveComment')}}</button>
    </div>
    <textarea class="input-dark form-control" :placeholder="$t('modems.enterComment')" v-model="newComment"></textarea>
  </div>
</div>`;

export { Template };



// WEBPACK FOOTER //
// ./src/app/js/components/page2_modems/left_menu/template.js